import VerificationCard from 'components/organisms/VerificationCard';

export default function Verification() {
  return <VerificationCard />;
}
